<dx-popup
  (onHiding)="popupHiding($event)"
  [dragEnabled]="false"
  [enableBodyScroll]="false"
  [fullScreen]="appService.isSmallScreen()"
  [height]="'auto'"
  [showCloseButton]="false"
  [showTitle]="true"
  [visible]="true"
  [width]="660"
  [wrapperAttr]="{
    class: 'chartPopupWrapper'
  }"
  contentTemplate="popupContent"
  maxHeight="90vh"
  title="{{'CHART_CREATION.TITLE' | translate}}">
  <dxi-toolbar-item
    location="after"
    toolbar="bottom">
    <dx-button (onClick)="createRequestSent= true; closeDialog.emit(newUserMetricGroup);"
               [disabled]="!isNewFormValid || createRequestSent"
               [stylingMode]="'contained'" [type]="'default'"
               icon="save" text="{{'BUTTONS.SAVE' | translate}}"></dx-button>
  </dxi-toolbar-item>
  <dxi-toolbar-item
    location="after"
    toolbar="bottom">
    <dx-button (onClick)="closeDialog.emit(false);" [disabled]="createRequestSent" [stylingMode]="'outlined'"
               icon="close" text="{{'BUTTONS.CANCEL' | translate}}"></dx-button>
  </dxi-toolbar-item>

  <!-- ******************************** -->
  <!-- Popup Contents                   -->
  <!-- ******************************** -->

  <div *dxTemplate="let data of 'popupContent'">
    <div style="height: auto; overflow: hidden">
      <dx-text-box
        (onEnterKey)="checkValidationAndSave()"
        (onValueChanged)="checkNewGroupValidation($event)"
        [(value)]="newUserMetricGroup.name"
        [label]="translate.instant('CHART_CREATION.NAME')"
        [maxLength]="gmService.STR_DIM_MAX"
        [valueChangeEvent]="'keyup'">
        <dxi-validation-rule message="Il nome è obbligatorio" type="required"></dxi-validation-rule>
      </dx-text-box>
    </div>
  </div>
</dx-popup>
